const GetSpendDetailReducer = (state = { type: 'LOADING_SPEND_DETAIL_VIEW_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_SPEND_DETAIL_VIEW_ACTION':
            return action
        default:
            return state
    }
}

export {
    GetSpendDetailReducer
}